import Vue from 'vue'
import VueRouter from 'vue-router'

import Workschedule from '@/router/workschedule'
import WorkScheduleSwap from '@/router/workscheduleSwap'
import WorkScheduleSwapCancellation from '@/router/workscheduleSwapCancellation'
import DutyShift from '@/router/dutyshift'
import Alocation from '@/router/alocation'
import VerifyCheck from '@/router/verifyCheck'
import VerifyCheckToken from '@/router/verifyCheckToken'
import CheckScheduleDeviations from '@/router/checkScheduleDeviations'
import Requirement from '@/router/requirement'
import User from './user'
import Profile from './profile'
import Check from './check'
import MyChecks from './myChecks'
import TeamChecks from './teamChecks'
import CheckExports from './checkExports'
import Import from './import'
import BaseAddressImport from './baseAddressImport'
import VacationImportRoute from './vacationImport'
import AditionalHour from './aditionalHour'
import ManualCheck from './manualCheck'
import Holidays from './holidays'
import CheckRequest from './checkRequest'
import CheckAdjustmentRequest from './checkAdjustmentRequest'
import Worktime from './worktime'
import PointMirror from './pointMirror'
import Vacation from './vacations'
import AbsenceRequest from './absenceRequest'
import Departments from './departments'
import Roles from './roles'
import Configuration from './configuration'
import TransportationRequest from './transportationRequest'
import Company from './company'
import CheckCam from './checkCam'
import Logs from './logs'
import ChecksTrashed from './checksTrashed'
import Lookup from './lookup'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    User,
    Profile,
    Check,
    MyChecks,
    TeamChecks,
    AditionalHour,
    ManualCheck,
    Holidays,
    CheckRequest,
    CheckAdjustmentRequest,
    Worktime,
    PointMirror,
    AbsenceRequest,
    Departments,
    Roles,
    Vacation,
    Configuration,
    TransportationRequest,
    Company,
    CheckCam,
    Workschedule,
    WorkScheduleSwap,
    WorkScheduleSwapCancellation,
    DutyShift,
    Alocation,
    CheckExports,
    Import,
    BaseAddressImport,
    VacationImportRoute,
    VerifyCheckToken,
    VerifyCheck,
    CheckScheduleDeviations,
    Requirement,
    Lookup,
    Logs,
    ChecksTrashed,
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/Home.vue'),
      meta: {
        pageTitle: 'Home',
        breadcrumb: [
          {
            text: 'Home',
            active: true,
          },
        ],
      },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/importar-j4',
      name: 'importar-j4',
      component: () => import('@/views/ImportarJ4.vue'),
      meta: {
        pageTitle: 'Importar J4',
        breadcrumb: [
          { text: 'Importar J4', active: true },
        ],
      },
    },
    {
      path: '/importar-j4-tih',
      name: 'importar-j4-tih',
      component: () => import('@/views/ImportarJ4_TIH.vue'),
      meta: {
        pageTitle: 'Importar J4 (TIH)',
        breadcrumb: [
          { text: 'Importar J4 (TIH)', active: true },
        ],
      },
    },
  ],
})

router.beforeEach((to, from, next) => {
  const is_admin = localStorage.getItem('is_admin')
  const terms = localStorage.getItem('accept_terms')
  const authenticated = localStorage.getItem('token')
  let to_splited = to.path.toString().split('/')
  to_splited = to_splited.filter(part => part !== '')

  if (
    !authenticated
        && (
          !(['/login'].includes(to.path.toString()))
            && !(['public'].includes(to_splited[0]))
        )
  ) {
    next('/login')

    return true
  }

  if (to.meta.is_admin) {
    if (!to.meta.is_admin.includes(is_admin)) {
      next('/')
    }
  }

  next()
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
